import { COUNTRY_CODE } from "constants/countries";
import { CURRENCY } from "constants/currencies";

import { ACCOUNT_TYPES } from "../constants/AccountFormState";

import type { CountryCode } from "models/CountryCode";
import type { Currency } from "models/Currency";

interface GetAccountCountrySpecificTypeParams {
  country?: CountryCode;
  currency?: Currency;
}

export function getAccountCountrySpecificType({
  country,
  currency,
}: GetAccountCountrySpecificTypeParams) {
  if (country === COUNTRY_CODE.GB && currency?.id === CURRENCY.GBP) {
    return ACCOUNT_TYPES.GBP_AND_UK;
  }

  if (country !== COUNTRY_CODE.GB && currency?.id === CURRENCY.GBP) {
    return ACCOUNT_TYPES.GBP_AND_ANY;
  }

  if (country === COUNTRY_CODE.BR && currency?.id === CURRENCY.BRL) {
    return ACCOUNT_TYPES.BR_AND_BRL;
  }

  return ACCOUNT_TYPES.ANY;
}
